import React,{useState,useEffect} from 'react';
import {
    Row,
    Col,
    Button,
    Label,
    FormGroup
  } from "reactstrap";
import StorageConfigService from '../../services/api/StorageConfig';
import ExternalMountService from '../../services/api/Mount';
import Select from 'react-dropdown-select';
import { toast } from 'react-toastify';
import Chip from '@material-ui/core/Chip';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import { default_LabelStorageName } from '../../settings/shared/constants';


export default function MountBucket(props) {

const [getStorageData, setStorageData] = useState({val: [], callBack: null});
const [getBucketData, setBucketData] = useState([]);
const [getMountedList, setMountedList] = useState([]);
const [getRoot, setRoot] = useState("");
const [getStorageFileId, setStorageFileId] = useState("");
const [getStorageId, setStorageId] = useState("");



const GetAllStorageConfig = () => {
  StorageConfigService.getAllStorageConfig()
  .then((response) => {
      if (response.status === 'SUCCESS') {
        let configData = response.storageDTOPage.content;
        for (let i = 0; i < configData.length; i++) {
          configData[i].label = configData[i].platformDefault ? default_LabelStorageName : configData[i].name;
          configData[i].value = configData[i].id;
        }
        setStorageData({val: configData, callBack: () => {
          var modelspaceOpenNotebook = JSON.parse(localStorage.getItem("savedNoteBook"))
          let fileId = modelspaceOpenNotebook[props.activeIndex].fileId;
          if(fileId !== undefined){
            setStorageFileId(fileId)   // set Modelspace Id
            getAllMountsByStorageFileId(fileId);
          }
        }});
      } else {
      toast.error(response.errorMessage);
      }
  }
  );
}

const removeChip = (id, index) => {
  props.closeModal();
  confirmAlert({
    title: 'Unmount Storage',
    message: "Are you sure to unmount this storage?",
    buttons: [
      {
        label: 'Yes',
        onClick: e => RemoveBucket(id)
      },
      {
        label: 'No',
        onClick: () => console.log('')
      }
    ]
  });
};

const RemoveBucket  = (id) =>{
  ExternalMountService.UnmountBucket(id)
  .then((response) => {
      if (response.status === 'SUCCESS') {
        toast.success("Unmounted Successfully")
        getAllMountsByStorageFileId(getStorageFileId);
      } else {
      toast.error(response.errorMessage);
      }
  }
  );
}


useEffect(() => {
  // Init method
  GetAllStorageConfig()
}, [props]);

useEffect(() => {
  GetAllStorageConfig()
  const {callBack} = getStorageData
  callBack && callBack()
}, [getStorageData])


const AddNewMount = () => {
  if(getStorageId === undefined && getStorageId === ""){
    toast.error("Please Select Storage")
  } 
  else{
  let dataMount = {
    id: getStorageFileId,
    rootFolder: getRoot,
    storageId: getStorageId
  }
  // console.log(dataMount)
  ExternalMountService.createMount(dataMount)
  .then((response) => {
      if (response.status === 'SUCCESS') {
        toast.success("Additional Mount Added Successfully");
        getAllMountsByStorageFileId(getStorageFileId);
      } else {
      toast.error(response.errorMessage);
      }
  }
  );
  }
}

const getAllMountsByStorageFileId = (fileId) =>{
  ExternalMountService.getAllMountsByStorageFileId(fileId)
  .then((response) => {
      if (response.status === 'SUCCESS') {
        let mountDTO = response.additionalMountDTOPage.content;
        setMountedList(mountDTO.map(mountItem => {
          const storageItems = getStorageData.val
          let index = storageItems.findIndex(item => item.id === mountItem.storageId)
          if (index !== -1) {
            mountItem.storageName = storageItems[index].name;
          } else {
            mountItem.storageName = mountItem.id
          }
          return mountItem;
        }))
      } else {
      toast.error(response.errorMessage);
      }
  });
}


  const handleChangeStorage = (e) =>{ 
    // If single selection 
    if(e !== null){
      const storageItems = getStorageData.val
      var index = storageItems.findIndex(item => item.id === e[0].value)
      setStorageId(storageItems[index].id);  // set storage Id
      let storage = storageItems[index];
      if(!storage.platformDefault && storage.storageType !== null && storage.storageType !== undefined && storage.storageType === "BUCKET"){
         var buckets = storageItems[index].storageConfig.bucketStorages;
            for (let j = 0; j < buckets.length; j++) {
              buckets[j].label = buckets[j].bucketName;
              buckets[j].value = buckets[j].bucketName;
            }
            setBucketData(buckets)
      } else {
        setBucketData([]);
      }
    }
   }

   const handleChangeStorageBucket = (e) =>{
    // If single selection 
    if(e !== null){
      setRoot(e[0].value)
    }
   }
    return (
      <div>
        <Row style={{ marginRight: 10 }}>
          <Col>

            <Label md="12">Select Storage</Label>
            <FormGroup>
              <Select className="selectMargin"
                closeMenuOnSelect={false}
                values={getStorageData.val.filter(item => item.value == "")}
                options={getStorageData.val} onChange={e => handleChangeStorage(e)} />
            </FormGroup>
          </Col>
        </Row>

            {getBucketData.length !== 0 && <Row style={{marginRight:10}}>
                <Col>
                <Label md="12">Select Bucket</Label>
                        <FormGroup>
                        <Select className="selectMargin"
                          closeMenuOnSelect={false}
                          values={getBucketData.filter(item => item.value == "")}
                          options={getBucketData} onChange={e=>handleChangeStorageBucket(e)} />  
                       </FormGroup>
                      {/* <span className="labelModalBold">Select Bucket</span>

                      <select className="col-12 dropdownStyle" name="subBuckets" style={{padding:6}} id="subBuckets" onChange={e=>this.handleChangeStorageBucket(e)}>
                      {getBucketData.map((item, index) => (< option value={item.bucketName}>{item.bucketName}</option>))}
                      </select> */}
                </Col>
            </Row>}

            <Row style={{margin:0}}>
                <Col>
                <Button size="sm" onClick={e=>AddNewMount()} color="primary"><i className="fas fa-plus-circle"></i>&nbsp;&nbsp;Add</Button>
                </Col>
            </Row>

                                
                                    
            {getMountedList.length !== 0 &&<Row style={{margin:0}}>
                <Col>
                <span className="labelModalBold">Added Mount Storage</span>
                <hr className="hrStyle"/>
                <Row>
                {getMountedList.map((item, index) => (
                    <Col><Chip
                      label={item.platformDefault ? default_LabelStorageName : item.storageName + " / " + item.rootFolder}
                      size="small"
                      onDelete={(chip) => removeChip(item.id, index)}
                      className='chipStyleMount mt-0'
                    /></Col>))}
                </Row>
                </Col>
            </Row>}
      </div>
    );
  }
  